/**
 * Created by guangqiang on 2017/10/11.
 */

const RegExpr = {

  /**
   * 校验手机号
   * @param mobile
   * @returns {boolean}
   */
  checkMobile: mobile => {
    return /^[1][0-9]{10}$/.test(mobile)
  }
}

export {
  RegExpr
}



// WEBPACK FOOTER //
// ./src/utils/regex.js